import { createSelector } from 'reselect';

export const domain = ({ searchClientAndClaim }) => searchClientAndClaim;
export const getSearchClientAndClaimQuery = createSelector(domain, searchClientAndClaim => searchClientAndClaim.get('query'));
export const getSummary = createSelector(domain, searchClientAndClaim => searchClientAndClaim.get('searchSummary'));
export const getPage = createSelector(domain, searchClientAndClaim => searchClientAndClaim.get('page'));
export const getOrder = createSelector(domain, searchClientAndClaim => searchClientAndClaim.get('order'));
export const getTemplate = createSelector(domain, searchClientAndClaim => searchClientAndClaim.get('template'));
